export const DestinationContentTypes = {
    TAGLINE: 0,
    DESCRIPTION: 1,
    QUICK_FACT: 2,
    HIGHLIGHT: 3,
    GOOD_TO_KNOW: 4,
    ITINERARY: 5,
} as const;
